<div class="flex flex-col gap-5 overflow-y-auto pr-5 pl-6">
	<app-commission-details
		[selectedBrokerageType]="selectedBrokerageType$ | async"
		[brokerageTypeDisplayName]="brokerageTypeDisplayName$ | async"
	></app-commission-details>

	<app-container
		title="{{ brokerageTypeDisplayName$ | async }} Brokerage"
		[testHook]="testHooks.Container"
	>
		<div class="border-t border-grey-light pt-5">
			<app-brokerage
				[isClientBrokerage]="isClientBrokerage$ | async"
				label="Add brokerage"
				orientation="row"
				[showBrokerageNameAndLabel]="false"
			>
			</app-brokerage>
		</div>
	</app-container>
</div>
<div>
	<app-commission-statement-file-handler
		[selectedBrokerageType]="selectedBrokerageType$ | async"
	></app-commission-statement-file-handler>
</div>
